import React, {PropTypes as T} from 'react';

const ExternalLinkIcon = ({ width = 24, height = 24, color, className = '' }) => (
  <svg
    aria-label="External Link Icon"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
    fill={color}
    width={width}
    height={height}
    className={`icon__externallink ${className}`}>
    <path d="M506 19H130.993v175H6v300h300.01V394H506V19zM281.011 469H30.998V219h99.996v175h150.017
    v75zm0-100H155.993V219H281.01v150zm199.99 0h-174.99V194H155.992V44H481v325z" />
  </svg>
);

ExternalLinkIcon.propTypes = {
  width: T.number,
  height: T.number,
  color: T.string,
  className: T.string
};

export default  ExternalLinkIcon;



// WEBPACK FOOTER //
// ./frontend/react/components/common/icons/icon_external_link.js